import { faChevronDown } from "@jewlr/pro-regular-svg-icons/faChevronDown"
import PropTypes from "prop-types"
import { forwardRef, memo } from "react"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { cn } from "styles/utils"

const Select = forwardRef(
  (
    {
      chevronClassName,
      className,
      containerClassName,
      error,
      errorClassName,
      ...props
    },
    ref
  ) => (
    <div className={cn("relative w-full", containerClassName)}>
      <select
        className={cn(
          "h-46 border-grey-10 focus:border-primary relative w-full appearance-none rounded-none border bg-white px-8 align-top text-black outline-none focus:border-2",
          className
        )}
        ref={ref}
        {...props}
      />
      <FontAwesomeIcon
        className={cn(
          "text-12 text-grey-65 pointer-events-none absolute right-8 top-16",
          chevronClassName
        )}
        icon={faChevronDown}
      />
      {error && (
        <p className={cn("text-error text-12 mt-8", errorClassName)}>
          {error.message || error}
        </p>
      )}
    </div>
  )
)

Select.propTypes = {
  chevronClassName: PropTypes.string,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  errorClassName: PropTypes.string,
}

Select.displayName = "Select"

export default memo(Select)
